import React, { useCallback, useMemo } from "react";
import { useWatch } from "react-hook-form";
import { StyledFormGrid } from "customStyled";
import { ResendOtp } from "Reuse/UI";
import OtpFieldReact from "./UI/OtpFieldReact";

/**
 * OTP UI Component
 * @param {number} count - Countdown in seconds until OTP can be resent
 * @param {object} props - `form` (react-hook-form via useAppForm) and `keyName`
 *                         (the array of OTP digits), passed to the OTP boxes
 */
const OtpInput = ({ count, isLogin, type, ...props }) => {
  const { form, keyName = "otp" } = props;
  const error = useWatch({ control: form.control, name: "error" });
  const resetField = useCallback(() => {
    // Clear every OTP box
    (form.getValues(keyName) || []).forEach((_, i) =>
      form.setValue(`${keyName}.${i}`, ""),
    );
  }, [form, keyName]);
  const resendOtpUI = useMemo(
    () => (
      <ResendOtp
        resetField={resetField}
        error={error}
        count={count}
        isLogin={isLogin}
        type={type}
      />
    ),
    [count, error, isLogin, type, resetField],
  );

  return (
    <StyledFormGrid container spacing={0} sx={{ padding: 0 }}>
      <OtpFieldReact separator={<span>-</span>} {...props} length={6} />
      {resendOtpUI}
    </StyledFormGrid>
  );
};

export default OtpInput;
